import { SetPortIdReturn, SetPortReturn } from 'store/actions/userActions';
import { PlanType, PortType, TagType, VesselCategoryType } from 'types';
import { SystemType } from 'types/system';
import { dateTimeFormat, DateTimeFormat } from 'utils/dateTimeFormat';

import { SetSystemReturn } from 'store/actions/layoutActions';
import {
    SetDefaultDataReturn,
    SetPilotagePlansReturn,
    SetSystemUpdateReturn,
    SetTagsReturn,
    SetVesselCategoriesReturn,
} from '../actions/portActions';

export interface PortState {
    port: PortType | null;
    system: SystemType | null;
    tags: TagType[];
    vesselCategories: VesselCategoryType[];
    update: any | null;
    pilotagePlans: PlanType[];
    defaultData: object;
    portId: number | null;
    dateTimeFormat: DateTimeFormat | null;
}

const initialState: PortState = {
    tags: [],
    dateTimeFormat: null,
    vesselCategories: [],
    pilotagePlans: [],
    defaultData: {},
    portId: null,
    port: null,
    system: null,
    update: {},
};

type PortAction =
    | SetPortReturn
    | SetSystemReturn
    | SetSystemUpdateReturn
    | SetPilotagePlansReturn
    | SetTagsReturn
    | SetPortIdReturn
    | SetVesselCategoriesReturn
    | SetDefaultDataReturn;

// Define the reducer
export const portReducer = (state: PortState = initialState, action: PortAction): PortState => {
    switch (action.type) {
        case 'SET_PORT':
            console.log(`STORE : Port changed to ${action.payload.id}, pilotagePlans updated`);
            console.log(`STORE : update port complated`);
            // @ts-ignore
            return {
                ...state,
                portId: action.payload.id,
                port: action.payload,
                dateTimeFormat: new dateTimeFormat(action.payload?.time), //@ts-ignore
                pilotagePlans:
                    // @ts-ignore
                    action.payload?.meta_data?.pilotagePlans.plans.map((plan) => {
                        return {
                            ...plan,
                            value: false,
                            loading: false,
                        };
                    }) || [],
            };
        case 'SET_TAGS':
            // @ts-ignore
            return { ...state, tags: action.payload };
        case 'SET_DEFAULT_DATA':
            // @ts-ignore
            return { ...state, defaultData: action.payload };
        case 'SET_VESSEL_CATEGORIES':
            // @ts-ignore
            return { ...state, vesselCategories: action.payload };

        case 'SET_PORT_ID':
            // stop saving pilotagePlans
            // eslint-disable-next-line no-case-declarations
            // const storedPilotagePlans = JSON.parse(localStorage.getItem('pilotagePlans') || '{}');

            // console.log(`Port changed to ${action.payload} , pilotagePlans updated`);

            // return {
            //     ...state,
            //     // @ts-ignore
            //     portId: action.payload,

            //     pilotagePlans: storedPilotagePlans[`P-${action.payload}`]
            //         ? storedPilotagePlans[`P-${action.payload}`]
            //         : //@ts-ignore
            //           state?.port?.meta_data.pilotagePlans.plans.map((plan) => {
            //               return {
            //                   ...plan,
            //                   value: false,
            //                   loading: false,
            //               };
            //           }),
            // };
            //TODO // remove
            console.log(`STORE : Port changed to ${action.payload} , pilotagePlans updated`);

            return {
                ...state,
                // @ts-ignore
                portId: action.payload,
            };

        case 'SET_PILOTAGE_PLANS':
            // stop saving pilotagePlans
            // {
            //     const storedPilotagePlans = JSON.parse(localStorage.getItem('pilotagePlans') || '{}');
            //     //@ts-ignore
            //     storedPilotagePlans[`P-${state.portId}`] = action.payload;
            //     localStorage.setItem('pilotagePlans', JSON.stringify(storedPilotagePlans));
            // }

            return {
                ...state,
                // @ts-ignore
                pilotagePlans: action.payload,
                port: {
                    ...state.port,
                    // @ts-ignore
                    meta_data: {
                        ...state?.port?.meta_data,
                        // @ts-ignore
                        pilotagePlans: { ...state?.port?.meta_data.pilotagePlans, plans: action.payload },
                    },
                },
            };
        case 'SET_SYSTEM':
            // @ts-ignore
            return { ...state, system: action.payload };
        case 'SET_SYSTEM_UPDATE':
            // @ts-ignore
            return { ...state, update: action.payload };
        default:
            return state;
    }
};
